export default [

    {
        date: '2019-11-08',
        title: '',
        description: 'Implementing OAuth Login via Third Party Login like Facebook, Google, Twitter, ...'
    },
    {
        date: '2019-11-05',
        title: '',
        description: 'Getting Basic Auth api stuff working via JWT.'
    },
    {
        date: '2019-11-04',
        title: '',
        description: 'YouTube Catcher Database Modell created. API Endpoints prepared. Gallery List of existing Videos added'
    },
    {
        date: '2019-10-13',
        title: '',
        description: 'Creating an update section with history log for logging updates. \nPrepare Skills and Tools to be prefined in style.'
    },
    {
        date: '2019-10-12',
        title: '',
        description: 'Create Basic structure'
    }

]
